module.exports = __webpack_public_path__ + "static/media/writing-instruction.277b6036.mp4";